import { render } from "./CouponDetail.vue?vue&type=template&id=fae3934a"
import script from "./CouponDetail.vue?vue&type=script&lang=js"
export * from "./CouponDetail.vue?vue&type=script&lang=js"

import "./CouponDetail.vue?vue&type=style&index=0&id=fae3934a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__